import React from "react";
import confirmDelete from "../../assets/Images/confirm delete.png";
import { ReactComponent as Cancel } from "../../assets/Icons/Cancel.svg";
import { CircularProgress } from "@mui/material";

const DeleteConfirmationDltModal = ({
  isOpen,
  onClose,
  handleDelete,
  loading,
}) => {
  
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        margin: 0,
      }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <span style={{ marginLeft: "auto", cursor: "pointer" }}>
              <Cancel onClick={onClose} />
            </span>
          </div>
          <div className="modal-body text-center">
            <img
              src={confirmDelete}
              alt="Warning"
              className="img-fluid mb-3"
              style={{ width: "250px" }}
            />
            <h5 className="modal-title">Confirm Deletion?</h5>
            <p className="mt-2">
              Information will be permanently erased and irretrievable.
            </p>
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-back"
              data-bs-dismiss="modal"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "3px",
              }}
              onClick={(e) => handleDelete()}
              disabled={loading}
            >
              {loading && (
                <CircularProgress
                  className="circular-loader"
                  style={{ width: "20px", height: "20px" }}
                />
              )}{" "}
              Delete Permanently
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationDltModal;
